// stereo-core: marching squares on a DensityGrid -> line segments in net coordinates.
// Copyright (C) 2026 DipField contributors. GPL-3.0-or-later.
import { DensityGrid } from "./density.js";
import { XY } from "./projection.js";

// [DEN-08]
export function contourSegments(g: DensityGrid, level: number): [XY, XY][] {
  const s = g.size, v = g.values, out: [XY, XY][] = [];
  const X = (c: number) => -1 + (2 * c) / (s - 1);
  const Y = (r: number) => 1 - (2 * r) / (s - 1);
  const lerp = (a: number, b: number) => (level - a) / (b - a);
  for (let r = 0; r < s - 1; r++) for (let c = 0; c < s - 1; c++) {
    const tl = v[r * s + c], tr = v[r * s + c + 1], br = v[(r + 1) * s + c + 1], bl = v[(r + 1) * s + c];
    const code = (tl >= level ? 8 : 0) | (tr >= level ? 4 : 0) | (br >= level ? 2 : 0) | (bl >= level ? 1 : 0);
    if (code === 0 || code === 15) continue;
    const top: XY = { x: X(c + lerp(tl, tr)), y: Y(r) };
    const right: XY = { x: X(c + 1), y: Y(r + lerp(tr, br)) };
    const bottom: XY = { x: X(c + lerp(bl, br)), y: Y(r + 1) };
    const left: XY = { x: X(c), y: Y(r + lerp(tl, bl)) };
    const center = (tl + tr + br + bl) / 4 >= level;
    switch (code) {
      case 1: case 14: out.push([left, bottom]); break;
      case 2: case 13: out.push([bottom, right]); break;
      case 3: case 12: out.push([left, right]); break;
      case 4: case 11: out.push([top, right]); break;
      case 6: case 9: out.push([top, bottom]); break;
      case 7: case 8: out.push([left, top]); break;
      case 5: if (center) { out.push([left, top], [bottom, right]); } else { out.push([left, bottom], [top, right]); } break;
      case 10: if (center) { out.push([top, right], [left, bottom]); } else { out.push([left, top], [bottom, right]); } break;
    }
  }
  return out;
}
